export default "../css/9c52fd6f7cd85eb278b21882e29fe17e.ttf";